import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/Icon';
import Image from 'components/Image';

const Home = () => (
  <Fragment>
    <section className="section section_home_1 section_home_1_ae">
      <div className="wrapper section__wrapper">
        <div className="row section__row">
          <div className="col col-5 col-tablet-12">
            <div className="section__content-wrap  _mb-tablet-44 _mt-tablet-0">
              <h4 className="title title_white section__sub-title _mb-laptop-4 _mb-9">
                Give your customers a
              </h4>
              <h1 className="title title_white section__title _mb-laptop-113 _mb-101">
                Website Builder
              </h1>
            </div>
          </div>
          <div className="col col-7 col-tablet-12">
            <div className="section__media-wrap">
              <video
                className="video section__video"
                autoPlay
                loop
                muted
                playsInline
                poster={require('../public/images/img-50.png')}
              >
                <source
                  src={require('../public/video/home.webm')}
                  type="video/webm"
                />
                <source
                  src={require('../public/video/home.mp4')}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_home_4 section_home_4_ae">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <div className="_mt-119 _mt-tablet-0 _mb-tablet-60">
              <h2 className="title title_size_l _mb-16">
                A white label website builder
              </h2>
              <p className="text _mb-36">
                Simply integrate Website Builder with your logo, colors, domain
                name, product plans in your existing systems while you maintain
                full control over billing, support, hosting and the customer
                relationship.
              </p>
              <Link
                to="/simple-integration"
                className="btn section__btn _mb-42"
              >
                Learn more
                <Icon className="btn__icon-arrow" icon="arrow-text-1" />
              </Link>
            </div>
          </div>
          <div className="col col-6 col-tablet-12">
            <div className="section__image-wrap">
              <Image className="section__image" src="white-label.svg" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_home_2 section_home_2_ae">
      <div className="wrapper">
        <div className="row row-reverse-tablet section__row">
          <div className="col col-6 col-tablet-12 section__col">
            <div className="section__images-group-wrap">
              <Image className="section__image-group_first" src="img-51.png" />
              <Image className="section__image-group_second" src="img-73.png" />
              <Image className="section__image-group_third" src="img-74.png" />
              <Image
                className="section__image-group_fourth"
                src="dng-hand.svg"
              />
            </div>
          </div>
          <div className="col col-5 col-tablet-12 offset-1 offset-tablet-0">
            <div className="section__content-wrap _mt-111 _mb-tablet-60 _mt-laptop-75 _mt-tablet-0">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Build with</span> Drag & Drop
              </h2>
              <p className="text _mb-36">
                Choose from hundreds of website templates and edit everything
                with Drag & Drop. It's so simple anyone can build their own
                website.
              </p>
              <Link to="/website-builder" className="btn section__btn _mb-42">
                Learn more
                <Icon className="btn__icon-arrow" icon="arrow-text-1" />
              </Link>
              <div className="section__image-elements-wrap">
                <Image src="img-52.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_home_3 section_home_3_ae">
      <div className="wrapper section__wrapper">
        <div className="row">
          <div className="col col-5 col-tablet-12">
            <div className="_mt-109 _mt-laptop-59 _mt-tablet-0 _mb-tablet-100">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Start selling</span> right away
              </h2>
              <p className="text _mb-36">
                Add your products and start selling. Our Online Store handles
                everything from secure payments to easy checkout, local taxes,
                shipping and more.
              </p>
              <Link to="/online-store" className="btn section__btn">
                Learn more
                <Icon className="btn__icon-arrow" icon="arrow-text-1" />
              </Link>
            </div>
          </div>
          <div className="col col-7 col-tablet-12">
            <div className="section__images-group-wrap">
              <Image src="img-53.jpg" />
              <Image className="section__image-group" src="img-53-1.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_home_5 section_home_5_ae">
      <div className="wrapper">
        <h2 className="title title_size_m section__title _mb-70 _mb-tablet-portrait-60">
          Trusted by industry leaders
        </h2>
        <div className="section__icons-container">
          <Icon
            className="section__icon section__icon_1"
            icon="network-solutions"
          />
          <Icon className="section__icon section__icon_7" icon="registercom" />
          <span className="section__icon-div _mb-40" />
          <Icon className="section__icon section__icon_2" icon="webcom" />
          <Icon className="section__icon section__icon_3" icon="crazydomains" />
          <span className="section__icon-div _mb-40" />
          <Icon className="section__icon section__icon_4" icon="sitebeat" />
          <Icon className="section__icon section__icon_5" icon="freeparking" />
          <span className="section__icon-div _mb-40" />
          <Icon className="section__icon section__icon_6" icon="domains4less" />
        </div>
      </div>
    </section>
  </Fragment>
);

export default Home;
